export enum AssignmentsEnum {
  DIVERGENCE = "DIVERGENCE",
  PAYROLL_VOUCHER = "PAYROLL_VOUCHER",
  PAYROLL_EXPORT = "PAYROLL_EXPORT",
  SHIPPING_RECIPIENT = "SHIPPING_RECIPIENT",
  USER = "USER",
  ACCESS_REQUEST = "ACCESS_REQUEST",
}
